// write a function to handle the request. this function should also create a requestHeader and passed into the request

export const request = async (url, options = {}) => {
  // Default headers
  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  // Get token from localStorage (using your existing pattern)
  const token = localStorage.getItem("token");
  if (token) {
    defaultHeaders.Authorization = `Token ${token}`;
  }

  // Merge headers - if specific headers are passed, they override defaults
  // Special case: if body is FormData, don't set Content-Type (let browser handle it)
  let finalHeaders = { ...defaultHeaders };

  if (options.headers) {
    finalHeaders = { ...defaultHeaders, ...options.headers };
  }

  // If body is FormData, remove Content-Type to let browser set it with boundary
  if (options.body instanceof FormData) {
    delete finalHeaders["Content-Type"];
  }

  const config = {
    ...options,
    headers: finalHeaders,
  };

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      const errorText = await response.text();
      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch {
        errorData = { message: errorText };
      }
      throw errorData;
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    } else {
      return await response.text();
    }
  } catch (error) {
    throw error;
  }
};

const createRequestHeader = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return {
      "Content-Type": "application/json",
    };
  }

  return {
    "Content-Type": "application/json",
    Authorization: `Token ${token}`,
  };
};
